import React from 'react';
import { Props as ButtonProps } from '../../../Button/Button';
import { StyledFmButton } from './FmButton.styles';

export interface Props extends Omit<ButtonProps, 'variant' | 'size' | 'variantColor'> {}

export const FmButton = React.forwardRef<HTMLButtonElement, Props>((props: Props, ref) => {
  return <StyledFmButton {...props} variant="secondary" ref={ref} />;
});
